import { Formik, Form } from 'formik';
import { ChangeEvent, useCallback, useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DefaultTheme, useTheme } from 'styled-components';
import * as yup from 'yup';
import { serialize } from 'object-to-formdata';
import { Breadcrumb } from '../../../components/Breadcrumb';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { UploadThumbnail } from '../../../components/UploadThumbnail';
import { IClient } from '../../../interfaces/IClient';
import { IFileImage } from '../../../interfaces/IFileImage';
import api from '../../../services/api';

const schema = yup.object({
  name: yup.string().required('Digite o nome'),
});

export const FormClient = () => {
  const theme: DefaultTheme = useTheme();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [thumbnail, setThumbnail] = useState<IFileImage>();
  const [loading, setLoading] = useState(false);
  const [client, setClient] = useState<IClient>();

  const onSelectFile = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const url = URL.createObjectURL(e.target.files[0]);
      setThumbnail({ file: e.target.files[0], url });
    }
  }, []);

  const handleSubmit = async (data: { name: string }) => {
    try {
      setLoading(true);
      if (!thumbnail && !id) {
        toast.error('Adicione a logo do cliente');
        return;
      }
      const dataFormatted = {
        name: data.name,
        file: thumbnail?.file,
      };
      const formData = serialize(dataFormatted);

      if (id) {
        await api.put(`/clients/${id}`, formData);
      } else {
        await api.post('/clients', formData);
      }
      toast.success('Cliente salvo com sucesso');
      history.push('/clients');
    } catch (err: any) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
        return;
      }
      toast.error('Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      api
        .get(`/clients/${id}`)
        .then(({ data }) => setClient(data))
        .catch(() => toast.error('Error ao buscar cliente'));
    }
  }, [id]);

  return (
    <>
      <Breadcrumb
        items={[
          {
            title: 'Clientes',
            link: '/clients',
          },
          {
            title: id ? 'Editar cliente' : 'Cadastro de cliente',
          },
        ]}
      />
      <Row className="d-flex align-items-center mt-4">
        <Col md={10} xs={9}>
          <h3>{id ? 'Editar cliente' : 'Novo cliente'}</h3>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={{ span: 8, offset: 2 }}>
          <Formik
            initialValues={client || { name: '' }}
            enableReinitialize
            onSubmit={handleSubmit}
            validationSchema={schema}
          >
            <Form>
              <UploadThumbnail
                onSubmit={onSelectFile}
                urlThumbnail={thumbnail?.url || client?.logo}
              />

              <Input type="text" name="name" placeholder="Nome do cliente" />

              <Col md={{ span: 4, offset: 4 }} xs={{ span: 6, offset: 3 }}>
                <Button
                  className="mt-4"
                  type="submit"
                  background={theme.colors.secondary}
                  loading={loading}
                  color="#fff"
                >
                  Salvar
                </Button>
              </Col>
            </Form>
          </Formik>
        </Col>
      </Row>
    </>
  );
};
